import { apiClient } from "@/lib/api-client";
import type {
  ForgotPasswordRequest,
  ResetPasswordVerifyResponse,
  ResetPasswordRequest,
  MessageResponse,
} from "@/types/api/auth";

/**
 * Request password reset for a user
 */
export async function requestPasswordReset(email: string): Promise<MessageResponse> {
  return apiClient<MessageResponse>("/auth/forgot-password", {
    method: "POST",
    body: JSON.stringify({ email } as ForgotPasswordRequest),
    requireAuth: false,
  });
}

/**
 * Verify a password reset token
 */
export async function verifyResetToken(token: string): Promise<ResetPasswordVerifyResponse> {
  return apiClient<ResetPasswordVerifyResponse>(
    `/auth/reset-password/verify?token=${encodeURIComponent(token)}`,
    {
      method: "GET",
      requireAuth: false,
    }
  );
}

/**
 * Reset password using a reset token
 */
export async function resetPassword(
  token: string,
  password: string,
  passwordConfirm: string
): Promise<MessageResponse> {
  return apiClient<MessageResponse>("/auth/reset-password", {
    method: "POST",
    body: JSON.stringify({
      token,
      password,
      password_confirm: passwordConfirm,
    } as ResetPasswordRequest),
    requireAuth: false,
  });
}

